<div>
    <div [innerHTML]="limitText()" class="text-container"></div>
    <div *ngIf="lineLimit > 0">
        <button matButton="elevated" (click)="toggleExpanded()" color="accent">
            {{ lable() }}
        </button>
    </div>
</div>